import { PagedResponseDTO } from '../_models/claim-operation-PagedResponseDTO.model copy';
import { ClaimOperationInfoDTO } from '../_models/claim-operation-ClaimOperationInfo.model';
import { EnumCompensation } from '../_enums/compensation';
import { EnumPaymentScheme } from '../_enums/payment-scheme';

export class ClaimOperationCP {
  claimID?: string;
  claimOperationID?: string;
  operationDate?: string;
  commerceNumber?: number;
  commerceName?: string;
  transactionType?: string;
  card?: string;
  arn?: string;
  claimOperation_Authorization?: string;
  amount?: number;
  nif?: string;
  entity?: string;
  dateLimit?: string;
  expirationDate?: string;
  subReasonName?: string;
  state?: number;
  stateName?: string;
  groupStateName?: string;
  rowNumber?: number;
  operationId?: number;
  isRequiredAction?: boolean;
  lastRequiredElements: string;
  lastStatusChange: string;
  typeOfCard:string;
  doc:string;
  currency: string;
  businessActivity: string;
  country: string;
  comments: string;
  operations_P37: string;
  contactIdGuid: string;
  compensation: string;
  paymentScheme: EnumPaymentScheme;
  operationTime: string;
  operations_P48: string;
  clientReason: string;
  

  constructor( item: ClaimOperationInfoDTO, response: PagedResponseDTO<ClaimOperationInfoDTO>) {
    this.claimID = String(item.claimID);
    this.claimOperationID = String(item.claimOperationID);
    this.operationDate = String(item.operationDate);
    this.commerceNumber = Number(item.commerceNumber);
    this.commerceName = item.contact_CommerceName;
    this.transactionType = item.transactionType;
    this.card = item.card;
    this.arn = item.arn;
    this.claimOperation_Authorization = item.authorization;
    this.amount = item.amount;
    this.nif = item.contact_DNI;
    this.entity = item.entidadBancaria;
    this.dateLimit = String(item.dateLimit);
    this.expirationDate = String(item.expirationDate);
    this.subReasonName = item.subReason_Name;
    this.state = item.state;
    this.stateName = item.stateName;
    this.rowNumber = item.rowNumber;
    this.operationId = item.id;
    this.lastRequiredElements = item.lastRequiredElements;
    this.typeOfCard = item.typeOfCard;
    this.doc = String(item.doc);
    this.currency = item.currency;
    this.businessActivity = String(item.businessActivity);
    this.country = item.country;
    this.comments = item.comments;
    this.operations_P37 = item.operations_P37;
    this.isRequiredAction = Boolean(item.isRequiredAction);
    this.lastStatusChange = item.lastStatusChange;
    this.contactIdGuid = item.contact_ContactIdGuid;
    this.compensation = EnumCompensation[item.compensation];
    this.paymentScheme = item.paymentScheme;
    this.operationTime = item.operationTime;
    this.operations_P48 = item.operations_P48;
    this.clientReason = item.clientReason;

  }
}
